module.exports = __webpack_public_path__ + "img/diamondMagic@2x.e88e73e.webp";